module.exports = __webpack_public_path__ + "img/icon_2_33.2a8cc324.png";